/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import { IMultiAxisDatasetVisitor } from '../../../../store/types/MultiAxisDatasetTypes';

interface IPositionVisitorContext {
    offset: number,
    sizeSum: number,
    sizeQueue: number[],
    viewportSize: number,
    preViewportSize: number,
    postViewportSize: number,
    viewportOffset: number,
    nodeIndex: number,
    nodePosition: number,
    done: boolean,

    sizeResolver(nodeIndex: number):number
}

const positionVisitor: IMultiAxisDatasetVisitor<IPositionVisitorContext> = {
    preVisitNode(node, ctxt) {
        const context = ctxt;
        if (!context.done && node.index >= 0) {
            if (node.index === context.nodeIndex) {
                context.nodePosition = context.offset + context.sizeSum;
            }

            const nodeSize = context.sizeResolver(node.index);
            context.sizeSum += nodeSize;
            context.sizeQueue.push(nodeSize);

            if (context.sizeSum > context.preViewportSize + context.viewportSize + context.postViewportSize) {
                const extraSize = context.sizeQueue.shift();
                context.offset += extraSize || 0;
                context.sizeSum -= extraSize || 0;
            }

            if (context.nodePosition >= 0) {
                context.done = context.nodePosition < context.offset + context.preViewportSize + context.viewportOffset;
            }
        }

        return context;
    },

    postVisit(ctxt) {
        if (ctxt.nodePosition < 0) {
            throw new Error('Desired element is not found!')
        }

        return ctxt;
    }
};

export default positionVisitor;
